import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import TabHeader from "../common/TabHeader";
import FileInput from "../common/FileInput";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { TEXT_NORMAL, TEXT_TITLE } from "../../style";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import { AUTHORITIES } from "../../constants";

export default function DialogCourseCarouselItem({
    visible,
    closeDialog,
    courseId,
    onAdded,
    onUpdated,
    id,
    source,
    click_link,
}) {
    const isEdit = !!id;
    const { requestAPI, showToast } = useAppContext();
    const [carouselImage, setCarouselImage] = useState({ source, click_link });
    const [loading, setLoading] = useState();

    const saveCarouselItem = useCallback(() => {
        if (isEdit) {
            requestAPI({
                requestPath: `courses/carousel`,
                requestMethod: "PATCH",
                requestPostBody: {
                    id,
                    source: carouselImage?.source,
                    click_link: carouselImage?.click_link || null,
                },
                setLoading: setLoading,
                onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Carousel Item !", life: 2000 }),
                onResponseReceieved: ({ error, ...item }, responseCode) => {
                    if (item?.id && responseCode === 200) {
                        showToast({ severity: "success", summary: "Updated", detail: "Carousel Item Updated", life: 1000 });
                        onUpdated?.(item);
                        closeDialog();
                    } else {
                        showToast({ severity: "error", summary: "Failed", detail: error || "Failed To Update Carousel Item !", life: 2000 });
                    }
                },
            });
            return;
        }

        requestAPI({
            requestPath: `courses/carousel`,
            requestMethod: "POST",
            requestPostBody: {
                course_id: courseId,
                source: carouselImage?.source,
                click_link: carouselImage?.click_link || null,
            },
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Add Carousel Item !", life: 2000 }),
            onResponseReceieved: ({ error, ...item }, responseCode) => {
                if (item?.id && responseCode === 201) {
                    showToast({ severity: "success", summary: "Added", detail: "Carousel Item Added", life: 1000 });
                    onAdded?.(item);
                    closeDialog();
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: error || "Failed To Add Carousel Item !", life: 2000 });
                }
            },
        });
    }, [carouselImage, closeDialog, courseId, id, isEdit, onAdded, onUpdated, requestAPI, showToast]);

    return (
        <Dialog
            header={isEdit ? "Edit Course Carousel Item" : "Add Course Carousel Item"}
            visible={visible}
            className="w-11"
            onHide={closeDialog}
            pt={{
                headertitle: { className: TEXT_TITLE },
                content: { className: "overflow-y-auto" },
            }}
        >
            <TabHeader
                className="pt-3"
                title={isEdit ? "Edit Course Carousel Item" : "Add Course Carousel Item"}
                highlights={["Images & GIFs Can Be Added As Carousel Items"]}
            />

            <FileInput
                className={"mt-3"}
                label="Carousel Item"
                type="image"
                cdn_url={carouselImage?.source}
                setCDNUrl={(cdn_url) => setCarouselImage((prev) => ({ ...prev, source: cdn_url }))}
                disabled={loading}
            />

            <FloatLabel className="mt-5">
                <InputText
                    value={carouselImage?.click_link || ""}
                    id="click_link"
                    className="w-full"
                    onChange={(e) => setCarouselImage((prev) => ({ ...prev, click_link: e.target.value }))}
                    disabled={loading}
                    pt={{
                        root: { className: TEXT_NORMAL },
                    }}
                />
                <label htmlFor="click_link" className={`${TEXT_NORMAL}`}>
                    Action URL
                </label>
            </FloatLabel>

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_COURSE}>
                <Button
                    className="mt-3"
                    label={isEdit ? "Update Carousel Item" : "Add Carousel Item"}
                    severity="warning"
                    loading={loading}
                    disabled={!carouselImage?.source}
                    onClick={saveCarouselItem}
                    pt={{
                        label: { className: TEXT_NORMAL },
                    }}
                />
            </HasRequiredAuthority>
        </Dialog>
    );
}
